import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { getCategories, getShopCategories } from '../grapql/categories';
import { mappingCategoriesShop } from '../utils/mappingCategories';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {
  private url = environment.api;

  constructor(
    private http: HttpClient,
  ) { }

  getCategories(): Observable<any> {
    return this.http.post<any>(`${this.url}`, {query: getCategories()}).pipe(
      map((res: any) => {
        return res.data.categoriaPrincipals;
      })
    );
  }

  getCategoriesShop():Observable<any> {
    return this.http.post<any>(`${this.url}`, {query: getShopCategories()}).pipe(
      map((res: any) => {
        return mappingCategoriesShop(res.data.categoriaPrincipals);
      })
    );
  }
}
